<template>
 <qd-loader :active="isLoading">
    <div class="columns mgb-20px" :class="{ 'min-height-100': isLoading }">
      <div class="column is-2 card mg-10px is-cursor-pointer"
          v-for="demandeEtat in demandesEtatResume" :key="demandeEtat.etat"
          @click="$emit('changeEtat', demandeEtat.etat)">
          <div class="columns">
            <div class="column is-12 mgl-10px is-flex is-vcentered">
              <b-icon
                icon="checkbox-blank-circle"
                :custom-class="getCouleurInformation(demandeEtat.etat).type"
                size="is-medium"
              ></b-icon>
              &nbsp;&nbsp;
              <p class="is-size-4 has-text-weight-semibold">
                <span class="has-text-primary lien">
                  {{ getLibelleEtat(demandeEtat.etat)}}
                </span>
                 : {{ demandeEtat.totalDemandeImpression }}
              </p>
            </div>
          </div>
          <div class="mg-10px">
            <div v-for="materielType in demandeEtat.demandeImpressionEtatMaterielTypes"
                :key="`${demandeEtat.etat}-${materielType.materielTypeLibelle}`">
              <span
                @click="makeSearchOnMaterialType(demandeEtat.etat,
                  materielType.materielTypeLibelle)"
                class="lien">
                {{ materielType.materielTypeLibelle }} :
                 {{ materielType.materielTypeCount }}
              </span>
            </div>
          </div>
      </div>
    </div>
  </qd-loader>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { getAllDemandeImpressionResumeAsync } from '@/api/logistique/demandeImpression/demandeImpressionRegroupement';
import messageErreur from '@/services/general/messageErreur';
import cloneDeep from 'lodash/cloneDeep';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { COULEUR_ETAT_DEMANDE_IMPRESSION, ETAT_DEMANDE_IMPRESSION } from '@/configuration/logistique/demandeImpression/demandeImpressionConf';

const DemandeImpression = createNamespacedHelpers('demandeImpression');

export default {
  name: 'demandeImpressionResume',
  data() {
    return {
      demandesEtatResume: [],
      isLoading: false,
    };
  },
  computed: {
    ...DemandeImpression.mapGetters({
      lastPayload: 'lastPayload',
    }),
  },
  methods: {
    async getInfos() {
      this.isLoading = true;
      try {
        const params = {
          query: cloneDeep(this.lastPayload.Query),
          limit: NO_PAGINATION,
        };
        this.demandesEtatResume = (await getAllDemandeImpressionResumeAsync(params)).data.result;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isLoading = false;
      }
    },
    getCouleurInformation(etatDemande) {
      return COULEUR_ETAT_DEMANDE_IMPRESSION.find(etat => etat.key === etatDemande);
    },
    getLibelleEtat(etatDemande) {
      const etatFind = ETAT_DEMANDE_IMPRESSION.find((etat) => {
        return etat.key === etatDemande;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : '';
    },
    makeSearchOnMaterialType(etat, materielTypeLibelle) {
      this.$emit('changeMaterielTypeLibelle', { etat, materielTypeLibelle });
    },
  },
  async mounted() {
    await this.getInfos();
  },
};
</script>

<style>

</style>
